<template>
    <CardShell>
          <!-- heading -->
        <BackLinkHeading linkText="Inbox" text="Enter Your Payment Info" :sizeDependent="false" route="/inbox"/>
        <PaymentDetails/>
    </CardShell>
</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import BackLinkHeading from '@/components/controls/BackLinkHeading.vue';
import PaymentDetails from '@/components/rent/payment/PaymentDetails.vue';

export default {
    components: {
        CardShell,
        BackLinkHeading,
        PaymentDetails
    }
};
</script>
